var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-layout"},[_c('HeaderHome',[_c('img',{attrs:{"slot":"logo","src":require("../assets/img/home/DDGLogoTop.png")},slot:"logo"})]),_c('div',{staticClass:"margin-top-content"}),_c('SliderFour'),_c('div',{staticClass:"mt--100 mt-sm-10"},[_c('About')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }